function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.875 10.5H12.75V14.875C12.75 17.3086 14.6914 19.25 17.125 19.25C19.5312 19.25 21.5 17.3086 21.5 14.875V10.5H22.375C22.5938 10.5 22.8125 10.3086 22.8125 10.0625V9.1875C22.8125 8.96875 22.5938 8.75 22.375 8.75H18.4375C18.1914 8.75 18 8.96875 18 9.1875V10.0625C18 10.3086 18.1914 10.5 18.4375 10.5H19.3125V14.875C19.3125 16.1055 18.3281 17.0625 17.125 17.0625C15.8945 17.0625 14.9375 16.1055 14.9375 14.875V10.5H15.8125C16.0312 10.5 16.25 10.3086 16.25 10.0625V9.1875C16.25 8.96875 16.0312 8.75 15.8125 8.75H11.875C11.6289 8.75 11.4375 8.96875 11.4375 9.1875V10.0625C11.4375 10.3086 11.6289 10.5 11.875 10.5ZM22.8125 21H11.4375C11.1914 21 11 21.2188 11 21.4375V22.3125C11 22.5586 11.1914 22.75 11.4375 22.75H22.8125C23.0312 22.75 23.25 22.5586 23.25 22.3125V21.4375C23.25 21.2188 23.0312 21 22.8125 21Z",
  fill: "#D5D7DE"
});

var SvgUnderline = function SvgUnderline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnderline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/underline.6a30c860.svg";
export { ForwardRef as ReactComponent };